module.exports = __webpack_public_path__ + "assets/img/ecologist.9f3ebdd5.png";